import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Download } from "lucide-react";

export default function AdminPaymentsTab({ apiUrl, getAuthHeaders }) {
  const credFetch = (url, opts = {}) => fetch(url, { ...opts, credentials: "include" });

  const [payments, setPayments] = useState([]);

  useEffect(() => { loadPayments(); }, []);

  const loadPayments = async () => {
    try {
      const res = await credFetch(`${apiUrl}/api/admin/payments`, { headers: getAuthHeaders(), credentials: "include" });
      const data = await res.json();
      if (data.success) setPayments(data.payments);
    } catch (error) { console.error("Payments error:", error); }
  };

  const exportData = async () => {
    try {
      const res = await credFetch(`${apiUrl}/api/admin/export/payments`, { headers: getAuthHeaders(), credentials: "include" });
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "payments_export.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
      toast.success("Payments exported");
    } catch (error) { toast.error("Export failed"); }
  };

  return (
    <div className="space-y-6" data-testid="admin-payments-tab">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-900">Payments</h2>
        <Button variant="outline" onClick={exportData}><Download className="w-4 h-4 mr-2" />Export CSV</Button>
      </div>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>User</TableHead><TableHead>Plan</TableHead><TableHead>Amount</TableHead><TableHead>Status</TableHead><TableHead>Payment ID</TableHead><TableHead>Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {payments.map((payment) => (
              <TableRow key={payment.id}>
                <TableCell>{payment.user_email}</TableCell>
                <TableCell className="capitalize">{payment.plan}</TableCell>
                <TableCell>{"\u20B9"}{payment.amount}</TableCell>
                <TableCell>
                  <Badge className={payment.status === "success" ? "bg-green-100 text-green-700" : payment.status === "pending" ? "bg-yellow-100 text-yellow-700" : "bg-red-100 text-red-700"}>{payment.status}</Badge>
                </TableCell>
                <TableCell className="text-xs text-gray-500">{payment.payment_id || "-"}</TableCell>
                <TableCell className="text-sm text-gray-500">{new Date(payment.created_at).toLocaleDateString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
